// Deliberately plain zustand `create` (not ./customCreate): the locale is a device
// preference that must survive resetAllStores() on logout.
import { create } from 'zustand';
import i18n from '@/i18n/i18n';
import { LOCALE, type Locale } from '@/modules/topbar/data/types';

function resolveInitialLocale(): Locale {
  const resolved = i18n.resolvedLanguage ?? i18n.language;
  return resolved === LOCALE.Nl ? LOCALE.Nl : LOCALE.En;
}

interface LocaleState {
  locale: Locale;
  setLocale: (next: Locale) => void;
}

export const useLocaleStore = create<LocaleState>()((set, get) => {
  const sync = (lng: string) => {
    const next: Locale = lng === LOCALE.Nl ? LOCALE.Nl : LOCALE.En;
    if (get().locale !== next) {
      set({ locale: next });
    }
  };

  i18n.on('languageChanged', sync);

  return {
    locale: resolveInitialLocale(),
    setLocale: (next) => {
      if (get().locale === next) return;
      void i18n.changeLanguage(next);
      set({ locale: next });
    },
  };
});
